import { Injectable } from '@angular/core';
import { DropDownListElement } from '../../shared/utility/drop-down-list-element';

@Injectable({
  providedIn: 'root'
})
export class ObservationTypeListHelperService {
  getObservationTypes(): DropDownListElement[] {
    return [{ text: 'Lesson Note' }, { text: 'Safeguarding' }, { text: 'Engagement' }, { text: 'Internal Comment' }, { text: 'Other' } ];
  }
}
